module.exports = __webpack_public_path__ + "img/image12.31b6a08a.png";